'use strict';

/**
 * Thin axios wrappers for the markup-sessions REST API.
 * Every call sends withCredentials so the session cookie ride-alongs.
 */

import axios from 'axios';

const base = '/api/markup-sessions';

axios.defaults.withCredentials = true;

export async function listSessions() {
  const { data } = await axios.get(`${base}`);
  return data.sessions || [];
}

export async function getSession(id) {
  const { data } = await axios.get(`${base}/${id}`);
  return data;
}

export async function createSession({ sourceS3Key, sourceFilename, sourceFileId, title, pageCount, markups }) {
  const { data } = await axios.post(`${base}`, { sourceS3Key, sourceFilename, sourceFileId, title, pageCount, markups });
  return data.id;
}

export async function renameSession(id, title) {
  return axios.patch(`${base}/${id}`, { title });
}

export async function deleteSession(id) {
  return axios.delete(`${base}/${id}`);
}

export async function bulkSaveMarkups(id, markups) {
  return axios.put(`${base}/${id}/markups`, { markups });
}

export async function addMarkup(id, markup) {
  const { data } = await axios.post(`${base}/${id}/markups`, { markup });
  return data;
}

export async function editMarkup(id, idx, patch) {
  return axios.patch(`${base}/${id}/markups/${idx}`, { markup: patch });
}

export async function deleteMarkup(id, idx) {
  return axios.delete(`${base}/${id}/markups/${idx}`);
}

export async function renderSession(id, opts = {}) {
  const { data } = await axios.post(`${base}/${id}/render`, opts, { timeout: 6 * 60 * 1000 });
  return data;
}

export async function listVersions(id) {
  const { data } = await axios.get(`${base}/${id}/versions`);
  return data.versions || [];
}

export async function listChats(id, markupIdx) {
  const url = markupIdx === undefined || markupIdx === null
    ? `${base}/${id}/chats`
    : `${base}/${id}/chats?markupIdx=${markupIdx}`;
  const { data } = await axios.get(url);
  return data.turns || [];
}

export async function postChat(id, { message, markupIdx }) {
  const { data } = await axios.post(`${base}/${id}/chats`, { message, markupIdx }, { timeout: 90_000 });
  return data;
}

export function sourcePdfUrl(id) {
  return `${base}/${id}/pdf`;
}

// Per-page extracted PDF. The studio loads this instead of the full source
// so the browser never has to handle a 500 MB+ construction drawing set.
export function pagePdfUrl(id, n) {
  return `${base}/${id}/pages/${n}.pdf`;
}

// { pageCount, pages: [{w, h}, ...] } — used by the studio to render page
// nav + thumbnails without ever loading the full source PDF.
export async function getPdfInfo(id) {
  const { data } = await axios.get(`${base}/${id}/pdf-info`, { timeout: 5 * 60 * 1000 });
  return data;
}
